/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CheckImeiAvailableServiceResponse } from '../models/CheckImeiAvailableServiceResponse';
import type { CheckImeiHistoryResponse } from '../models/CheckImeiHistoryResponse';
import type { CheckImeiServiceListingResponse } from '../models/CheckImeiServiceListingResponse';
import type { UpdateAvailableServiceRequest } from '../models/UpdateAvailableServiceRequest';
import type { UseCheckImeiServiceRequest } from '../models/UseCheckImeiServiceRequest';
import type { UseCheckImeiServiceResponse } from '../models/UseCheckImeiServiceResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CheckImeiService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns CheckImeiAvailableServiceResponse OK
     * @throws ApiError
     */
    public getAvailableServices(): CancelablePromise<CheckImeiAvailableServiceResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/check-imei/services',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public updateAvailableService({
        requestBody,
    }: {
        requestBody: UpdateAvailableServiceRequest,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/check-imei/services',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public createDefaultServices(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/check-imei',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns UseCheckImeiServiceResponse OK
     * @throws ApiError
     */
    public performAction({
        requestBody,
    }: {
        requestBody: UseCheckImeiServiceRequest,
    }): CancelablePromise<UseCheckImeiServiceResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/check-imei/action/use',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns CheckImeiHistoryResponse OK
     * @throws ApiError
     */
    public getServiceHistory({
        ownerId,
        ownerType,
        page,
        size,
        from,
        to,
        imeiOrSerial,
    }: {
        ownerId: string,
        ownerType: 'SHOP' | 'REVENUE' | 'THIRD_PARTY' | 'CLEARING' | 'BANKS' | 'FINANCIER',
        page: number,
        size: number,
        from?: string,
        to?: string,
        imeiOrSerial?: string,
    }): CancelablePromise<CheckImeiHistoryResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/check-imei/services/history',
            query: {
                'from': from,
                'to': to,
                'imeiOrSerial': imeiOrSerial,
                'ownerId': ownerId,
                'ownerType': ownerType,
                'page': page,
                'size': size,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns CheckImeiServiceListingResponse OK
     * @throws ApiError
     */
    public getServiceListing(): CancelablePromise<CheckImeiServiceListingResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/check-imei/services/active',
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
